import {Controller} from "stimulus";

export default class extends Controller {
  static targets = ["queue", "reminder"];

  initialize() {
    this.audio = new Audio('/ding.mp3');
    this.counter = document.getElementById('reminder-count');
    document.addEventListener('dashboard.call.started', event => {
      this.clearReminder(event.detail.contact);
    });
  }

  addReminder(data) {
    if (this.hasReminderTarget) {
      for (let target of this.reminderTargets) {
        if (target.dataset.id == data.id) {
          return;
        }
      }
    }
    $(this.queueTarget).prepend(data.contact);
    this.setReminderNumber();
    this.playSound();
  }

  clearReminder(id) {
    console.log('in clear reminder id is: ' + id);
    for (let target of this.reminderTargets) {
      console.log('target id is: ' + target.dataset.id)
      if (target.dataset.id == id) {
        target.remove();
      }
    }
  }

  setReminderNumber() {
    try {
      this.counter.innerText = this.reminderTargets.length;
      if (this.reminderTargets.length > 0) {
        this.counter.style.display = 'flex';
      }
      else {
        this.counter.style.display = 'none';
      }
    }
    catch {
      console.log('error setting reminder count');
    }
  }

  playSound() {
    var playPromise = this.audio.play();
    if (playPromise !== undefined) {
      playPromise.then(_ => {
        // Automatic playback started!
      }).catch(error => { console.log(error.message); });
    }
  }
}